import type { ScreenItem } from 'shared/src/types';
import { WEB_ROUTE_PATHS } from 'shared/src/webRoutePaths';
import { HomeScreen } from './screens/Home/Home.screen';
import { CategoryScreen } from './screens/Category';
import { TodayShippingScreen } from './screens/TodayShipping';
import { ContentsScreen } from './screens/Contents';
import { LikeScreen } from './screens/Like';
import { LikeMarketListScreen } from './screens/LikeMarketList';
import { EditGoodsLikeScreen } from './screens/EditGoodsLike';
import { MyPageScreen } from './screens/MyPage';
import { GoodsRankingScreen } from './screens/Home/GoodsRanking.screen';
import { MarketRankingScreen } from './screens/Home/MarketRanking.screen';

export type HomeStackParamList = {
  Home: {
    selected?: string;
    market_type_sno?: string;
  };
  EditGoodsLike: {
    instanceId?: string;
    categorySno?: number | null;
    isDeliveryFilterOn?: boolean;
    order?: string | null;
  };
};

export const HomeScreens: ScreenItem[] = [
  // {
  //   name: 'Home',
  //   component: HomeScreen,
  //   path: '/',
  //   options: {
  //     tabBarLabel: '홈',
  //   },
  // },
  // {
  //   name: 'Category',
  //   component: CategoryScreen,
  //   path: '/category',
  //   options: {
  //     tabBarLabel: '카테고리',
  //   },
  // },
  {
    name: 'EditGoodsLike',
    component: EditGoodsLikeScreen,
    path: WEB_ROUTE_PATHS.EditGoodsLike,
    options: {
      title: '전체 상품 - 에이블리 스토어',
    },
    convertParams: props => {
      const extras =
        typeof props.extras === 'string'
          ? (() => {
              try {
                return JSON.parse(props.extras as string);
              } catch {
                return {};
              }
            })()
          : (props.extras ?? {});

      return {
        categorySno:
          typeof extras.category_sno === 'string'
            ? Number(extras.category_sno)
            : (extras.category_sno ?? null),
        isDeliveryFilterOn:
          typeof extras.is_fast_delivery === 'string'
            ? extras.is_fast_delivery === 'true'
            : Boolean(extras.is_fast_delivery),
        order: extras.order ?? null,
      };
    },
  },
  {
    name: 'LikeMarketList',
    component: LikeMarketListScreen,
    path: '/like-markets',
  },
  {
    name: 'GoodsRanking',
    component: GoodsRankingScreen,
    path: '/goods-ranking',
  },
  {
    name: 'MarketRanking',
    component: MarketRankingScreen,
    path: '/market-ranking',
  },
  {
    name: 'LikeFragment',
    component: LikeScreen,
    path: '/like-fragment',
  },
  {
    name: 'FragmentsOverView',
    component: CategoryScreen,
    path: '/fragments/overview',
  },
];
export const HomeTabScreens: ScreenItem[] = [
  {
    name: 'Home',
    component: HomeScreen,
    path: '/:selected?',
    options: {
      tabBarLabel: '홈',
    },
  },
  {
    name: 'Category',
    component: CategoryScreen,
    path: '/overview',
    options: {
      tabBarLabel: '카테고리',
    },
  },
  {
    name: 'TodayShipping',
    component: TodayShippingScreen,
    path: '/today-shipping',
    options: {
      tabBarLabel: '오늘출발',
    },
  },
  {
    name: 'Contents',
    component: ContentsScreen,
    path: '/contents',
    options: {
      tabBarLabel: '콘텐츠',
    },
  },
  {
    name: 'Like',
    component: LikeScreen,
    path: '/like',
    options: {
      tabBarLabel: '찜',
    },
  },
  {
    name: 'MyPage',
    component: MyPageScreen,
    path: '/mypage',
    options: {
      tabBarLabel: '마이페이지',
    },
  },
];
